import { deleteBook as destroyBook } from "../../../books/actions";

const deleteBook = (id) => {
  return async (dispatch) => {
    await fetch(`http://localhost:9000/books/${id}`, {
      method: "DELETE",
    });

    dispatch(destroyBook(id));
  };
};

export default deleteBook;
